import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { applicationInfoType } from "types/app";
import SimpleDialog from "./InnerSimpleDialog";

interface IBasicMenuProps {
	ApplicationInfo: applicationInfoType[];
	ApplicationItem: applicationInfoType;
	setApplicationInfo: (value: applicationInfoType[]) => void;
}
const BasicMenu: React.FC<IBasicMenuProps> = ({
	ApplicationItem,
	ApplicationInfo,
	setApplicationInfo,
}) => {
	// About Menu
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	// About Dialog
	const [openModal, setModalOpen] = React.useState(false);
	const [selectedMenuType, setSelectedMenuType] = React.useState(0);

	const handleModalClickOpen = (e: React.MouseEvent<HTMLElement>) => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};
	return (
		<span>
			<IconButton
				aria-label="more"
				id="long-button"
				aria-controls="long-menu"
				aria-expanded={open ? "true" : "false"}
				aria-haspopup="true"
				onClick={handleClick}
				sx={{
					borderRadius: "50%",
				}}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
			>
				<MenuItem
					onClick={(e) => {
						handleClose();
						setSelectedMenuType(0);
						handleModalClickOpen(e);
					}}
				>
					{t("application_change_name")}
				</MenuItem>
				<MenuItem
					onClick={(e) => {
						handleClose();
						setSelectedMenuType(1);
						handleModalClickOpen(e);
					}}
				>
					{t("application_delete")}
				</MenuItem>
			</Menu>
			<SimpleDialog
				ApplicationInfo={ApplicationInfo}
				ApplicationItem={ApplicationItem}
				selectedMenuType={selectedMenuType}
				openModal={openModal}
				handleModalClose={handleModalClose}
				setApplicationInfo={setApplicationInfo}
			/>
		</span>
	);
};
export default BasicMenu;
